<template>
    <div class="create-selector-container mt-10">
        <div class="block-card-heading">Choose the blockchain to which you wish to write.</div>
        <hr class="margin-top: 0.7rem;">
        <div class="container">
            <div class="row m-auto">
                <!-- List of Blockchains -->
                <template v-for="(bc, i) in utils.blockchains">
                    <div :key="i" class="col-sm-6 col-md-6 col-lg-4">
                        <div class="selector-wrapper">
                            <label class="checkbox checkbox-lg checkbox-single">
                                <input :value="bc" @click="onCheck(i)" v-model="utils.checkedBlockchain" type="checkbox" />
                                <span></span>
                            </label>
                            <label class="selector-label">
                                <img :src="'/media/logos/' + bc.toLowerCase() + '.png'" alt="icon"
                                     style="margin-top: -3px;"
                                     v-if="bc !== 'None'"
                                     width="18"/>
                                {{ bc }}
                            </label>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

   import {bus} from '../../../main';

   export default {
      name: "ListOfBlockchains",
      data() {
         return {
            utils: {
               blockchains: [
                  'None',
                  'Ethereum',
                  'Tezos',
                  'Chainlink',
                  'EOS',
                  'Cardano'
               ],
               checkedBlockchain: ['None'],
            }
         }
      },
      methods: {
         onCheck(i) {
            let cb = this.utils.blockchains[i];
            this.utils.checkedBlockchain = [cb];
            bus.$emit('emit_selected_blockchain', cb);
         }
      }
   }
</script>

<style scoped>

</style>